module.exports = __webpack_public_path__ + "ce654ff0.svg";